import { render, staticRenderFns } from "./relationList.vue?vue&type=template&id=868a706e"
import script from "./relationList.vue?vue&type=script&lang=js"
export * from "./relationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports